/**
 * API Configuration Utility
 * Detects environment and provides correct API base URL
 * Includes all hostname variations for dev/prod Cloudflare Pages
 */

export function getApiBaseUrl() {
  const hostname = window.location.hostname

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8787'
  }

  // Dev environment - includes custom domain AND Pages.dev domains
  if (hostname === 'dev.contentindexer.com' ||
      hostname.includes('.dev.contentindexer.com') ||
      hostname.includes('contentindexer-marketing-dev.pages.dev')) {
    return 'https://api.dev.contentindexer.com'
  }

  // Production - includes custom domain AND Pages.dev domains
  if (hostname === 'contentindexer.com' ||
      hostname === 'www.contentindexer.com' ||
      hostname.includes('contentindexer-marketing.pages.dev')) {
    return 'https://api.contentindexer.com'
  }

  // Default to dev (safer than production)
  return 'https://api.dev.contentindexer.com'
}

/**
 * Make authenticated API request
 * Uses JWT token for authentication (not API keys - those are for developers)
 */
export async function apiCall(endpoint, options = {}) {
  const authToken = localStorage.getItem('authToken')
  const baseUrl = getApiBaseUrl()
  const url = `${baseUrl}${endpoint}`

  const headers = {
    'Content-Type': 'application/json',
    ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
    ...options.headers,
  }

  const response = await fetch(url, {
    ...options,
    headers,
  })

  // Return response object instead of throwing, let caller handle errors
  return response
}

/**
 * Initiate OAuth flow
 */
export function initiateOAuth(provider) {
  const apiUrl = getApiBaseUrl()
  const frontendUrl = encodeURIComponent(window.location.origin)
  const redirectUrl = `${apiUrl}/v1/auth/${provider}?frontend_url=${frontendUrl}`
  console.log(`Redirecting to ${provider} OAuth: ${redirectUrl}`)
  window.location.href = redirectUrl
}

export const API_CONFIG = {
  endpoints: {
    auth: (provider) => `${getApiBaseUrl()}/v1/auth/${provider}`,
  },
  getBaseUrl: getApiBaseUrl,
}
